export default __webpack_public_path__ + "static/media/img--pool-2.fbbdb17f.jpg";